export type RecordingHit = {
  name: string;
  display_name: string;
  preview?: string;
};

export const getRecordingLabel = (recording: RecordingHit): string =>
  recording.display_name || recording.name;
